import React from "react";

function HeroSkeleton() {
  return (
    <div className="w-full h-[550px] inline-block cursor-pointer relative p-2 bg-gray-400 animate-pulse rounded-md"></div>
  );
}

export default HeroSkeleton;
